<template>
  <form
    class="food-searchbox main"
    autocomplete="off"
    @submit.prevent="do_search"
  >
    <div
      v-if="error_message"
      class="error p-2 alert alert-danger"
      v-text="error_message"
    />
    <input
      autocomplete="off"
      name="hidden"
      type="text"
      style="display:none;"
    >
    <div class="input">
      <input
        v-model="query"
        type="text"
        class="form-control fff-ui"
        name="s"
        placeholder="Type a food you want to lookup here"
        aria-label="Type a food you want to lookup here"
        autocomplete="off"
        @focus="debounced_show_results"
        @keyup="debounced_show_results"
      >
      <button
        class="button"
        type="submit"
      >
        Search
      </button>
    </div>
    <div
      v-show="results_showing"
      class="results"
    >
      <div class="title">
        {{ results_title }}
      </div>
      <div
        v-for="(result, index) in results"
        class="result"
        @click="select_result(index)"
      >
        <div class="icon">
          <i class="fas fa-search" />
        </div>
        <div class="info">
          {{ result }}
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import foodcleaner from '../components/FoodSearchShared'
import { debounce } from "lodash";

export default {
  props:{
    onResults:{ type: Function }
  },
  data () {
    return {
      query: '',
      results: Array,
      results_title: [],
      results_showing: false,
      itemData:[],
      past_searches: [],
      debounced_show_results: undefined,
      error_message: '',
    };
  },
  computed: {
    searched() {
      return !!this.query;
    }
  },
  watch: {
    '$route.query.s': function (s) {
      // Note: Does not seem to be triggered
      this.set_search();
    },
  },
  created() {
    // Detect 'meal-log-entry-added' event at the root level
    this.$root.$el.addEventListener('meal-log-entry-added', this.resetSearchBox);

    this.debounced_show_results = debounce(this.show_results, 1000);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$el.removeEventListener('meal-log-entry-added', this.resetSearchBox);
  },
  async mounted () {
    var self = this;
    this.set_search();
    document.addEventListener('click', function(e){
      if (!e.target.closest('.food-searchbox .results') && !e.target.closest('.food-searchbox .input')) {
        self.results_showing = false;
      }
    });

    let pastsearches = await this.$http('/api/fooditems/pastsearches',{
      method:"get",
    }).then(response => response.json())
      .then(async function(json) {
        return json.data;
      });
    this.results_title = 'Past Searches';
    this.results = pastsearches;
    this.past_searches = pastsearches;
  },
  methods: {
    /**
         * Clear search box and perform blank search
         */
    resetSearchBox() {
      this.query = '';
      this.do_search();
    },
    async do_search() {
      if (this.query === '') {
        return;
      }

      // Affects loading spinner
      this.$emit('search-start');

      this.results_showing=false;

      try {
        let searchitemsdata = await foodcleaner.search2(this.query);

        console.log(searchitemsdata);
        searchitemsdata.query = this.query;
        this.onResults(searchitemsdata);
      } catch (e) {
        if (e.name !== 'AbortError') {
          throw e;
        }
      } finally {
        this.$emit('search-end');
      }
    },
    set_search() {
      this.query = this.$route.query.s ?? '';

      if (this.query !== '') {
        this.do_search();
      }
    },
    async show_results(event) {
      if (event.key === 'Enter') {
        // Since the enter key is pressed, we know the form was submitted,
        // meaning `do_search` should have been called.
        console.log('searched enter');
        this.results_showing = false;
        this.do_search();

        return;
      }

      this.results_showing = true;
      this.error_message = '';

      if(typeof(this.query)!='undefined' && this.query.length==0){
        this.results_title = 'Past Searches';
        this.results = this.past_searches;
      }else{
        try {
          let searchitems = (await foodcleaner.search(this.query, 0, {
            'perpage': 1000,
            'ignoresearch': true,
          })).data;
          let suggestsearches=[];
          if(searchitems.length>0){
            for(let i=0; i<searchitems.length; i++){
              suggestsearches.push(searchitems[i].name);
            }
          }
          this.results_title = 'Suggestions';
          this.results = suggestsearches;
        } catch (e) {
          if (e.name === 'AbortError') {
            return;
          }

          this.error_message = e;

          throw e;
        }
      }
    },
    select_result(index) {
      this.query = this.results[index];
      this.results_showing = false;
      this.do_search();
    },
  },
}
</script>

<style lang="scss" scoped>
.food-searchbox.main {
    display: block;
    max-width: 640px;
    margin: 0 auto;
    position: relative;
}
.input {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    z-index: 2
}
.input input {
    flex: 1;
    min-width: 0;
    font-size: 20px;
    font-weight: 700;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.input .button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.results {
    width: 100%;
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    background: #fff;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    overflow: hidden;
    padding-bottom: 8px;
    z-index: 1;
    max-height: 336px;
    overflow-y: auto;
}
.results .title {
    background: #f0f0f0;
    padding: 8px 12px;
    color: #888;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
}
.results .result {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    font-size: 16px;
    padding: 12px 12px 12px 0;
    font-weight: 700;
    cursor: pointer;
}
.results .result:hover {
    background: #f0f0f0;
}
.results .icon {
    width: 40px;
    text-align: center;
    color: rgba(95, 159, 59, 1);
}
.results .info {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
